export interface ApiDocEndpoint {
    method: 'GET' | 'POST' | 'PUT' | 'DELETE';
    path: string;
    summary: string;
    description: string;
    requestBody?: any;
    responseBody?: any;
    queryParams?: Record<string, string>;
    customBaseUrl?: string;
}

export interface DocSection {
    title: string;
    description: string;
    endpoints: ApiDocEndpoint[];
}

export const API_DOCS: DocSection[] = [
    {
        title: 'Query Execution',
        description: 'Execute queries against terminals or snapshot storage.',
        endpoints: [
            {
                method: 'POST',
                path: '/queries/{queryId}/execute',
                summary: 'Execute Query (Live)',
                description: 'Run query against a live terminal database.',
                requestBody: {
                    terminalId: "T123",
                    parameters: { visitId: "V_99" },
                    returnResults: true
                },
                responseBody: { status: "SUCCESS", results: [] }
            },
            {
                method: 'POST',
                path: '/queries/{queryId}/execute',
                summary: 'Execute Query (Snapshot)',
                description: 'Run query against cached snapshot results instead of live DB.',
                requestBody: {
                    terminalId: "T123",
                    parameters: { visitId: "V_99" },
                    returnResults: true,
                    snapshot: true
                },
                responseBody: { status: "SUCCESS", source: "SNAPSHOT", results: [] }
            },
            {
                method: 'POST',
                path: '/queries/{queryId}/versions/{versionNumber}/execute',
                summary: 'Execute Version (Live)',
                description: 'Run a specific version of a query against a live terminal.',
                requestBody: {
                    terminalId: "T123",
                    parameters: { visitId: "V_99" },
                    returnResults: true
                },
                responseBody: { status: "SUCCESS", version: "1.0.0", results: [] }
            },
            {
                method: 'POST',
                path: '/queries/{queryId}/versions/{versionNumber}/execute',
                summary: 'Execute Version (Snapshot)',
                description: 'Run a specific version against snapshot storage.',
                requestBody: {
                    terminalId: "T123",
                    parameters: { visitId: "V_99" },
                    returnResults: true,
                    snapshot: true
                },
                responseBody: { status: "SUCCESS", source: "SNAPSHOT", version: "1.0.0", results: [] }
            }
        ]
    }
];
